import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import offlineIcon from '../../offline-icon.svg';
import NPaper from '../NPaper';


const useStyles = makeStyles(theme => ({
  mediaContainer: {
    [theme.breakpoints.down('xs')]: {
      height: '28vw'
    },
    [theme.breakpoints.up('sm')]: {
      height: '16vw'
    },
    [theme.breakpoints.up('md')]: {
      height: '12vw'
    },
    [theme.breakpoints.up('lg')]: {
      height: 160
    },
    overflow: 'hidden',
    textAlign: 'center'
  },
  mediaOnline: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  mediaOffline: {
    height: '100%',
    opacity: 0.1
  }
}));


function Picture(props) {
  const { image } = props;
  const classes = useStyles();

  const [offline, setOffline] = useState(image == null);

  return (
    <NPaper className={classes.mediaContainer}>
      <img
        alt="Latest"
        src={offline ? offlineIcon : image.urls?.small}
        className={offline ? classes.mediaOffline : classes.mediaOnline}
        onError={() => setOffline(true)}
      />
    </NPaper>
  );
}

export default Picture;
